import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Auth } from '../../providers/auth';
import { LoadingController } from 'ionic-angular';
import { HomePage } from '../home/home'; 
import { AboutPage } from '../about/about'; 
import { LoginPage } from '../login/login'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';

@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html'
})
export class ProfilePage {
  username: string;
  password: string;
  email: string;
  fullname:string;
  sex:string;
  education:string;
  birthDate: string;

  errorMessage: string;
  loader:any;
  iagree: boolean;

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public translate: TranslateService, public userdataModel:UserdataModel, public navCtrl: NavController, private storage: Storage, public auth: Auth, public loadingCtrl: LoadingController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    
    this.username="";
    this.password="";
    this.email="";
    this.fullname="";
    this.sex="";
    this.education="";
    this.birthDate="";

    this.errorMessage="";
    this.iagree=false;
  }
  
  ionViewWillEnter(){
    this.functions.changeShowSidemenuButtonTo(true);
    if(this.userdataModel.userdata[0].username){ this.username=this.userdataModel.userdata[0].username; }
    if(this.userdataModel.userdata[0].password){ this.password=this.userdataModel.userdata[0].password; }
    if(this.userdataModel.userdata[0].email){ this.email=this.userdataModel.userdata[0].email; }
    if(this.userdataModel.userdata[0].fullname){ this.fullname=this.userdataModel.userdata[0].fullname; }
    if(this.userdataModel.userdata[0].sex){ this.sex=this.userdataModel.userdata[0].sex; }
    if(this.userdataModel.userdata[0].education){ this.education=this.userdataModel.userdata[0].education; }
    if(this.userdataModel.userdata[0].birthDate){ this.birthDate=this.functions.convertStringDateForViz(this.userdataModel.userdata[0].birthDate); }
  }

  goToLogin(){
    this.navCtrl.push(HomePage, {});
  }

  goToDisclaimer(){
    this.navCtrl.push(AboutPage, {});
  }

  editProfile(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();
        this.auth.editProfile(this.username,this.password,this.email,this.fullname,this.sex,this.birthDate,this.education).then((response)=>{
          var responseString:string;
          responseString=response.toString();
          if(responseString.indexOf('EditProfileIsOk')!=-1){
            //this.navCtrl.push(HomePage, {});
           }else{
             this.errorMessage=this.auth.errorMessage;
             this.loader.dismiss();
             return;
          }
        });
    }else{
      this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
    }
  }

  logoutCurrentProfile(){
    if(this.functions.deviceIsOnline()){
      this.presentLoading();
        this.auth.logout().then((response)=>{
          var responseString:string;
          responseString=response.toString();
          console.log("responseString:"+responseString);
          if(responseString.indexOf('LogoutIsOk')!=-1){
            this.loader.dismiss();
            this.navCtrl.setRoot(LoginPage, {});
           }else{
             this.errorMessage=this.auth.errorMessage;
             this.loader.dismiss();
             return;
          }
        });
    }else{
      this.translate.get('noConnection').subscribe(value => { this.errorMessage = value;});
    }
  }
    
  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      content: "Caricamento..."
    });
    this.loader.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts